import React from "react";
import * as kyclistservice from "../../services/kyc/kyc-list-service";
import DataTable from "../../components/data-table";
import DatePicker from "react-datepicker";
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import {
  dateFormat,
  StringToDate,
  DateToString,
  dateFormatWithTime,
} from "../../utils/date";
import { Link } from "react-router-dom";
import { Authorize } from "../../components/authorize";
import * as Loader from "../../common/common";
import { FUNCTIONALITY, ENTITLEMENTS } from "../../common/const";
import * as xmlService from "../../services/xml/xml-service";
import { validateEntitlement } from "../../common/validate-entitlement";
import * as clientsearchservice from "../../services/client/client-search-service";
import * as validate from "../../utils/validations";
import XmlDownload from "../../components/xml-download/xml-download";

export default class KycList extends Authorize {
  constructor(props) {
    super(props);

    this.resetDate = this.resetDate.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onKeyPressDate = this.onKeyPressDate.bind(this);
  }

  state = {
    dateFrom: "",
    dateTo: "",
    validationErrors: {},
    message: "",
    data: [],
    headers: [
      { title: "Name", accessor: "name", index: 0, dataType: "string" },
      { title: "Client Type", accessor: "type", index: 1, dataType: "string" },
      { title: "KYC Status", accessor: "status", index: 2, dataType: "string" },
      {
        title: "Submission Date",
        accessor: "submittedOn",
        index: 3,
        dataType: "string",
      },
      {
        title: "Number of Days Overdue",
        accessor: "daysOverdue",
        index: 4,
        dataType: "string",
      },
      {
        title: "Details",
        accessor: "",
        index: 5,
        cell: (row) => {
          return (
            <div>
              <Link
                to={{
                  pathname: "/kycs/" + row.clientId + "/" + row.type,
                  state: row.name,
                }}
              >
                View
              </Link>
            </div>
          );
        },
      },
    ],
    default: "UNAPPROVED",
    statusTab: "",
    regenerateMsg: "",
    excelHeaders: [
      { label: "Name", key: "name" },
      { label: "Client Type", key: "type" },
      { label: "KYC Status", key: "status" },
      { label: "Submission Date", key: "submittedOn" },
      { label: "Number of Days Overdue", key: "daysOverdue" },
      { label: "Details", key: "details" },
    ],
  };
  onKeyPressDate = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let errorName = name + "Error";
    if (value?.length > 10) {
      e.preventDefault();
      return false;
    }
    this.setState({
      [name]: value,

      validationErrors: {
        ...this.state.validationErrors,
        [errorName]: "",
      },
    });
  };
  handleChange(name, date) {
    if (date !== undefined && date !== null && date !== "") {
      let formatedDate = dateFormat(date);
      this.setState({
        [name + 1]: date,
        [name]: formatedDate,
      });
    }
  }

  resetDate() {
    this.setState({
      dateFrom: "",
      dateFrom1: "",
      dateTo: "",
      dateTo1: "",
      validationErrors: "",
    });
  }

  onKeyPressDateValidation = (e) => {
    if (validate.isValidKeyPressDate(e.which)) {
      e.preventDefault();
      return false;
    }
  };

  async getKycList(status, dateDefault) {
    let dataObject = {
      dateFrom:
        status === "UNAPPROVED"
          ? ""
          : dateDefault
          ? dateFormatWithTime(
              new Date(new Date().getFullYear(), new Date().getMonth(), 1)
            )
          : dateFormatWithTime(StringToDate(this.state.dateFrom)),
      dateTo:
        status === "UNAPPROVED"
          ? ""
          : dateDefault
          ? dateFormatWithTime(
              new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
            )
          : dateFormatWithTime(StringToDate(this.state.dateTo)),
      status: status,
    };
    Loader.showLoader();
    let { response, err } = await kyclistservice.getKycList(dataObject);
    if (err) {
      this.setState({
        message: "Error: " + err,
      });
    } else if (response && response.data.err) {
      this.setState({
        message: "Error: " + response.data.err,
      });
    } else {
      Loader.hideLoader();
      this.setState({
        ...this.state,
        data: response.data,
        statusTab: status,
        dateFrom: dateDefault
          ? dateFormat(
              DateToString(
                new Date(new Date().getFullYear(), new Date().getMonth(), 1)
              )
            )
          : this.state.dateFrom,
        dateTo: dateDefault
          ? dateFormat(
              DateToString(
                new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
              )
            )
          : this.state.dateTo,
        dateFrom1: 
          StringToDate(
            dateDefault
              ? dateFormat(
                  DateToString(
                    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
                  )
                )
              : this.state.dateFrom
          )
        ,
        dateTo1: 
          StringToDate(
            dateDefault
              ? dateFormat(
                  DateToString(
                    new Date(
                      new Date().getFullYear(),
                      new Date().getMonth() + 1,
                      0
                    )
                  )
                )
              : this.state.dateTo
          )
        
      });
    }
  }

  onSubmit(e) {
    let validationErrors = {};
    let state = Object.assign({}, this.state);
    let validationFlag = false;
    if (!state.dateFrom) {
      validationErrors.dateFrom = "Enter From Date";
      validationFlag = true;
    } else if (!validate.isValidDateFormat(state.dateFrom)) {
      validationErrors.dateFrom = "Enter From Date in dd-mm-yyyy format";
      validationFlag = true;
    }
    if (!state.dateTo) {
      validationErrors.dateTo = "Enter To Date";
      validationFlag = true;
    } else if (!validate.isValidDateFormat(state.dateTo)) {
      validationErrors.dateTo = "Enter To Date in dd-mm-yyyy format";
      validationFlag = true;
    } else if (StringToDate(state.dateFrom) > StringToDate(state.dateTo)) {
      validationErrors.dateTo = "From date cannot be greater than to date";
      validationFlag = true;
    }
    if (validationFlag === false) {
      this.getKycList(this.state.statusTab, false);
    }
    this.setState({
      ...this.state,
      validationErrors: validationErrors,
    });
  }

  componentDidMount() {
    this.getKycList("UNAPPROVED");
  }

  async regenerateXml(clientId, userType) {
    let data = {
      clientId: clientId,
      userType: userType,
    };
    Loader.showLoader();
    let { response, err } = await xmlService.regenerateXml(data);
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      this.setState(
        {
          regenerateMsg: response.data.msg,
        },
        () => {
          setTimeout(() => this.setState({ regenerateMsg: "" }), 1000);
        }
      );
    }
  }

  async regenerateCFSMAGXml(clientId, userType) {
    let data = {
      clientId: clientId,
      userType: userType,
    };
    Loader.showLoader();
    let { response, err } = await xmlService.regenerateCFSMAGXml(data);
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      this.setState(
        {
          regenerateMsg: response.data.msg,
        },
        () => {
          setTimeout(() => this.setState({ regenerateMsg: "" }), 1000);
        }
      );
    }
  }

  async updateClient(clientId, action) {
    Loader.showLoader();
    let { response, err } = await clientsearchservice.updateClient(
      clientId,
      action
    );
    Loader.hideLoader();
    if (err) {
      this.setState({
        message: err,
      });
    } else if (response && response.data.err) {
      this.setState({
        message: response.data.err,
      });
    } else {
      this.getKycList(this.state.statusTab, false);
    }
  }

  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    var d = new Date();
    var dateTime =
      d.getFullYear() +
      "-" +
      d.getMonth() +
      "-" +
      d.getDate() +
      "_" +
      d.getHours() +
      "-" +
      d.getMinutes() +
      "-" +
      d.getSeconds();
    let headers = [
      { title: "Name", accessor: "name", index: 0, dataType: "string" },
      { title: "Client Type", accessor: "type", index: 1, dataType: "string" },
      { title: "KYC Status", accessor: "status", index: 2, dataType: "string" },
      {
        title: "Submission Date",
        accessor: "submittedOn",
        index: 3,
        dataType: "string",
      },
      {
        title: "Details",
        accessor: "",
        index: 4,
        cell: (row) => {
          return (
            <div>
              <Link
                to={{
                  pathname: "/kycs/" + row.clientId + "/" + row.type,
                  state: row.name,
                }}
              >
                View
              </Link>
              {validateEntitlement(FUNCTIONALITY.kyc, ENTITLEMENTS.reopen) ? (
                <React.Fragment>
                  &nbsp; | &nbsp;
                  <a
                    href="#"
                    onClick={this.updateClient.bind(
                      this,
                      row.clientId,
                      "reopen"
                    )}
                    style={{ cursor: "pointer" }}
                  >
                    Re-Open
                  </a>
                </React.Fragment>
              ) : null}
              {validateEntitlement(
                FUNCTIONALITY.generateXMLCSV,
                ENTITLEMENTS.create
              ) && this.state.statusTab === "APPROVED" ? (
                <div className="dropdown">
                  <button
                    type="button"
                    className="btn dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    More
                  </button>
                  <div className="dropdown-menu">
                    {validateEntitlement(
                      FUNCTIONALITY.generateXMLCSV,
                      ENTITLEMENTS.create
                    ) && this.state.statusTab === "APPROVED" ? (
                      <React.Fragment>
                        <span
                          className="dropdown-item"
                          onClick={this.regenerateXml.bind(
                            this,
                            row.clientId,
                            row.type
                          )}
                        >
                          Regenerate INFOR XML
                        </span>
                        <XmlDownload
                          type="infor"
                          displayTitle="INFOR"
                          obj={{ clientId: row.clientId, userType: row.type }}
                        />
                      </React.Fragment>
                    ) : null}
                    {validateEntitlement(
                      FUNCTIONALITY.generateXMLCSV,
                      ENTITLEMENTS.create
                    ) &&
                    row.type === "Customer" &&
                    this.state.statusTab === "APPROVED" ? (
                      <React.Fragment>
                        <span
                          className="dropdown-item"
                          onClick={this.regenerateCFSMAGXml.bind(
                            this,
                            row.clientId,
                            row.type
                          )}
                        >
                          Regenerate CFS-MAG XML
                        </span>
                        <XmlDownload
                          type="cfs-mag"
                          displayTitle="CFS-MAG"
                          obj={{ clientId: row.clientId, userType: row.type }}
                        />
                      </React.Fragment>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </div>
          );
        },
      },
    ];
    const datatable = (
      <DataTable
        className="table"
        keyField="id"
        pagination={{
          enabled: true,
          pageLength: 20,
          type: "long",
        }}
        width="100%"
        headers={
          this.state.statusTab === "UNAPPROVED" ? this.state.headers : headers
        }
        data={this.state.data.length > 0 ? this.state.data : []}
        excelHeaders={this.state.excelHeaders}
        filename={this.state.statusTab + "_" + dateTime + ".csv"}
        pdfTitle={this.state.statusTab}
        noData="No records!"
      />
    );

    return (
      <React.Fragment>
        <div className="container-fluid kyc-list-wrapper mt-2 ml-2 mr-2 mb-2 pt-3">
          <div className="row">
            <div className="col-sm-12">
              <h4 className="d-xs-block d-sm-block d-md-none text-uppercase text-center mt-2 text-primary">
                {" "}
                KYC's
              </h4>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <a
                    onClick={this.getKycList.bind(this, "UNAPPROVED", true)}
                    className="nav-item nav-link active"
                    id="unapproved-tab"
                    data-toggle="tab"
                    href="#unapproved"
                    role="tab"
                    aria-controls="unapproved"
                    aria-selected="true"
                  >
                    UNAPPROVED
                  </a>
                  <a
                    onClick={this.getKycList.bind(this, "APPROVED", true)}
                    className="nav-item nav-link"
                    id="approved-tab"
                    data-toggle="tab"
                    href="#approved"
                    role="tab"
                    aria-controls="approved"
                    aria-selected="false"
                  >
                    APPROVED
                  </a>
                  <a
                    onClick={this.getKycList.bind(this, "REJECTED", true)}
                    className="nav-item nav-link"
                    id="rejected-tab"
                    data-toggle="tab"
                    href="#rejected"
                    role="tab"
                    aria-controls="rejected"
                    aria-selected="false"
                  >
                    REJECTED
                  </a>
                </div>
              </nav>
              <div className="tab-content" id="nav-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="unapproved"
                  role="tabpanel"
                  aria-labelledby="unapproved-tab"
                >
                  <div className="row mt-2">
                    <div className="col-sm-12">{datatable}</div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="approved"
                  role="tabpanel"
                  aria-labelledby="approved-tab"
                >
                  {this.state.statusTab !== "UNAPPROVED" ? (
                    <form>
                      <div className="row">
                        <div className="col-sm-12">
                          <span style={{ color: "red" }}>
                            {this.state.message}
                          </span>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <span className="datePickerSpan">From : </span>
                          <DatePicker
                            className={
                              this.state.validationErrors.dateFrom
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            dateFormat="dd-MM-yyyy"
                            maxLength="10"
                            placeholderText="dd-mm-yyyy"
                            name="dateFrom"
                            placeholder="dd-mm-yyyy"
                            selected={this.state.dateFrom1}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            onChange={this.handleChange.bind(this, "dateFrom")}
                            onChangeRaw={this.onKeyPressDate}
                            onKeyDown={this.onKeyPressDateValidation}
                            autoComplete="off"
                          />
                          <span className="error-msg">
                            {this.state.validationErrors.dateFrom}
                          </span>
                        </div>

                        <div className="col-sm-3">
                          <span className="datePickerSpan">To : </span>
                          <DatePicker
                            className={
                              this.state.validationErrors.dateTo
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            dateFormat="dd-MM-yyyy"
                            maxLength="10"
                            placeholderText="dd-mm-yyyy"
                            name="dateTo"
                            placeholder="dd-mm-yyyy"
                            selected={this.state.dateTo1}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            onChange={this.handleChange.bind(this, "dateTo")}
                            onChangeRaw={this.onKeyPressDate}
                            onKeyDown={this.onKeyPressDateValidation}
                            autoComplete="off"
                          />
                          <span className="error-msg">
                            {this.state.validationErrors.dateTo}
                          </span>
                        </div>
                        <div className="col-sm-2">
                          <div className="row">
                            <input
                              type="button"
                              className="btn btn-block btn-primary  rounded-0"
                              value="SUBMIT"
                              onClick={this.onSubmit}
                            />
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="row">
                            <input
                              type="button"
                              className="btn btn-block  btn-default rounded-0"
                              value="RESET"
                              onClick={this.resetDate}
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  ) : (
                    ""
                  )}

                  <div className="row mt-2">
                    {this.state.regenerateMsg ? (
                      <span style={{ color: "green" }}>
                        {this.state.regenerateMsg}
                      </span>
                    ) : null}
                    <div className="col-sm-12">{datatable}</div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="rejected"
                  role="tabpanel"
                  aria-labelledby="rejected-tab"
                >
                  {this.state.statusTab !== "UNAPPROVED" ? (
                    <form>
                      <div className="row">
                        <div className="col-sm-12">
                          <span style={{ color: "red" }}>
                            {this.state.message}
                          </span>
                        </div>
                      </div>
                      <div className="row">
                        {/* <div className="col-sm-1">
                                                    <label className="col-form-label" htmlFor="Date From">From :</label>
                                                </div> */}
                        <div className="col-sm-4">
                          <span className="datePickerSpan">From : </span>
                          <DatePicker
                            className={
                              this.state.validationErrors.dateFrom
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            dateFormat="dd-MM-yyyy"
                            maxLength="10"
                            placeholderText="dd-mm-yyyy"
                            name="dateFrom"
                            placeholder="dd-mm-yyyy"
                            selected={this.state.dateFrom1}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            onChange={this.handleChange.bind(this, "dateFrom")}
                            onChangeRaw={this.onKeyPressDate}
                            onKeyDown={this.onKeyPressDateValidation}
                            autoComplete="off"
                          />
                          <span className="error-msg">
                            {this.state.validationErrors.dateFrom}
                          </span>
                        </div>
                        {/* <div className="col-sm-1">
                                                    <label className="col-form-label" htmlFor="Date To">To : </label>
                                                </div> */}
                        <div className="col-sm-3">
                          <span className="datePickerSpan">To : </span>
                          <DatePicker
                            className={
                              this.state.validationErrors.dateTo
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            dateFormat="dd-MM-yyyy"
                            maxLength="10"
                            placeholderText="dd-mm-yyyy"
                            name="dateTo"
                            placeholder="dd-mm-yyyy"
                            selected={this.state.dateTo1}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            onChange={this.handleChange.bind(this, "dateTo")}
                            onChangeRaw={this.onKeyPressDate}
                            onKeyDown={this.onKeyPressDateValidation}
                            autoComplete="off"
                          />
                          <span className="error-msg">
                            {this.state.validationErrors.dateTo}
                          </span>
                        </div>
                        <div className="col-sm-2">
                          <div className="row">
                            <input
                              type="button"
                              className="btn btn-block btn-primary  rounded-0"
                              value="SUBMIT"
                              onClick={this.onSubmit}
                            />
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="row">
                            <input
                              type="button"
                              className="btn btn-block  btn-default rounded-0"
                              value="RESET"
                              onClick={this.resetDate}
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  ) : (
                    ""
                  )}

                  <div className="row mt-2">
                    <div className="col-sm-12">{datatable}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="row">
                        <div className="col-sm-12">
                            <div className="btn-group mb-2" role="group">
                                <button type="button" className="btn btn-warning mr-2 rounded-0" autoFocus={this.state.default === 'UNAPPROVED'} onClick={this.getKycList.bind(this, 'UNAPPROVED', true)} >UNAPPROVED</button>
                                <button type="button" className=" btn btn-success mr-2" onClick={this.getKycList.bind(this, 'APPROVED', true)} >APPROVED</button>
                                <button type="button" className=" btn btn-danger mr-2 rounded-0" onClick={this.getKycList.bind(this, 'REJECTED', true)} >REJECTED</button>
                            </div>
                        </div>
                    </div> */}
        </div>
      </React.Fragment>
    );
  }
}
